(() => {
class LcConditionGuide {
  constructor(root) {
    this.root = root;
    this.panels = [...root.querySelectorAll('[data-grade-panel]')];
    this.links = [...root.querySelectorAll('[data-grade-link]')];
    this.dialog = root.querySelector('[data-zoom-dialog]');
    this.zoomImage = root.querySelector('[data-zoom-image]');
    this.viewport = root.querySelector('[data-zoom-viewport]');
    this.canvas = root.querySelector('[data-zoom-canvas]');
    this.photoState = root.querySelector('[data-photo-state]');
    this.photoStatus = root.querySelector('[data-photo-status]');
    this.photoRecovery = root.querySelector('[data-photo-recovery]');
    this.zoomTools = root.querySelector('.lc-condition__zoom-tools');
    this.photoReady = false;
    this.level = 1;
    this.onHash = () => this.selectFromHash();
    this.onResize = () => { if (this.dialog.open) this.setZoom(this.level); };
    root.addEventListener('click', (event) => this.onClick(event));
    this.dialog.addEventListener('close', () => { clearTimeout(this.photoTimeout); this.photoReady = false; document.documentElement.style.overflow = this.previousOverflow || ''; this.opener?.focus({ preventScroll: true }); });
    this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } });
    this.zoomImage.addEventListener('load', () => { if (this.dialog.open && this.zoomImage.naturalWidth) { clearTimeout(this.photoTimeout); this.setPhotoState('ready'); this.setZoom(1); } });
    this.zoomImage.addEventListener('error', () => { if (this.dialog.open) { clearTimeout(this.photoTimeout); this.setPhotoState('error'); } });
    window.addEventListener('hashchange', this.onHash);
    window.addEventListener('resize', this.onResize);
    this.panels.forEach((panel) => { panel.querySelector('[data-game-controls]').hidden = false; this.selectGame(panel, 'pokemon'); });
    this.selectFromHash();
  }
  selectFromHash() {
    let id = window.location.hash.slice(1);
    if (id === 'good') id = 'slightly-played';
    if (!this.panels.some((panel) => panel.id === id)) id = this.panels.find((panel) => !panel.hidden)?.id || this.panels[0].id;
    this.selectGrade(id);
  }
  selectGrade(id) {
    this.panels.forEach((panel) => { panel.hidden = panel.id !== id; });
    this.links.forEach((link) => { if (link.dataset.gradeLink === id) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
  }
  selectGame(panel, game) {
    panel.querySelectorAll('[data-game]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.game === game)));
    panel.querySelectorAll('[data-photo-game]').forEach((figure) => { figure.hidden = figure.dataset.photoGame !== game; });
  }
  onClick(event) {
    const gradeLink = event.target.closest('[data-grade-link], [data-overview-link]');
    if (gradeLink) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const id = gradeLink.dataset.gradeLink || gradeLink.dataset.overviewLink;
      this.selectGrade(id);
      history.replaceState(null, '', '#' + id);
      if (gradeLink.hasAttribute('data-overview-link')) {
        const target = this.links.find((link) => link.dataset.gradeLink === id);
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      return;
    }
    const game = event.target.closest('[data-game]');
    if (game) { this.selectGame(game.closest('[data-grade-panel]'), game.dataset.game); return; }
    const photo = event.target.closest('[data-zoom-photo]');
    if (photo && typeof this.dialog.showModal === 'function') {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.opener = photo;
      this.level = 1;
      const img = photo.querySelector('img');
      this.zoomImage.alt = img.alt;
      this.root.querySelector('[data-zoom-title]').textContent = img.alt;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.loadPhoto(photo.href);
      this.root.querySelector('[data-zoom-close]').focus();
      return;
    }
    if (event.target.closest('[data-zoom-close]')) { this.dialog.close(); return; }
    if (event.target.closest('[data-photo-retry]')) { this.loadPhoto(this.photoUrl); return; }
    if (!this.photoReady) return;
    const action = event.target.closest('[data-zoom-action]')?.dataset.zoomAction;
    if (action === 'in') this.setZoom(this.level + .5);
    if (action === 'out') this.setZoom(this.level - .5);
    if (action === 'reset') this.setZoom(1);
    if (action === 'edges') this.setZoom(3, 0, .5);
    if (action === 'corners') this.setZoom(3, 0, 0);
    if (action === 'surface') this.setZoom(3, .5, .5);
  }
  setPhotoState(state) {
    const focused = document.activeElement;
    this.photoReady = state === 'ready';
    this.photoState.hidden = this.photoReady;
    this.photoRecovery.hidden = state !== 'error';
    this.zoomTools.hidden = !this.photoReady;
    this.viewport.hidden = !this.photoReady;
    this.photoStatus.textContent = state === 'error' ? this.photoStatus.dataset.error : (state === 'loading' ? this.photoStatus.dataset.loading : '');
    if (this.dialog.open && [this.photoState, this.photoRecovery, this.zoomTools, this.viewport].some((element) => element.hidden && element.contains(focused))) this.root.querySelector('[data-zoom-close]').focus({ preventScroll: true });
  }
  loadPhoto(src) {
    clearTimeout(this.photoTimeout);
    this.photoUrl = src;
    this.root.querySelector('[data-photo-original]').href = src;
    this.setPhotoState('loading');
    this.zoomImage.removeAttribute('src');
    this.zoomImage.src = src;
    this.photoTimeout = setTimeout(() => { if (this.dialog.open && !this.photoReady) this.setPhotoState('error'); }, 15000);
  }
  setZoom(level, x = .5, y = .5) {
    if (!this.photoReady) return;
    this.level = Math.min(4, Math.max(1, level));
    const ratio = (this.zoomImage.naturalWidth || 1800) / (this.zoomImage.naturalHeight || 2600);
    const baseHeight = Math.min(this.viewport.clientHeight - 36, (this.viewport.clientWidth - 36) / ratio);
    const width = baseHeight * ratio * this.level;
    const height = baseHeight * this.level;
    this.zoomImage.style.width = width + 'px';
    this.zoomImage.style.height = height + 'px';
    this.canvas.style.width = Math.max(this.viewport.clientWidth, width + 36) + 'px';
    this.canvas.style.height = Math.max(this.viewport.clientHeight, height + 36) + 'px';
    this.root.querySelector('[data-zoom-level]').value = Math.round(this.level * 100) + '%';
    this.root.querySelector('[data-zoom-action="out"]').disabled = this.level <= 1;
    this.root.querySelector('[data-zoom-action="in"]').disabled = this.level >= 4;
    this.viewport.scrollLeft = (this.viewport.scrollWidth - this.viewport.clientWidth) * x;
    this.viewport.scrollTop = (this.viewport.scrollHeight - this.viewport.clientHeight) * y;
  }
  destroy() { clearTimeout(this.photoTimeout); window.removeEventListener('hashchange', this.onHash); window.removeEventListener('resize', this.onResize); if (this.dialog.open) this.dialog.close(); }
}
const initConditionGuides = (scope = document) => { scope.querySelectorAll('[data-condition-guide]').forEach((root) => { if (!root.lcConditionGuide || root.lcConditionGuide.pending) root.lcConditionGuide = new LcConditionGuide(root); }); };
initConditionGuides();
document.addEventListener('shopify:section:load', (event) => initConditionGuides(event.target), true);
document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-condition-guide]').forEach((root) => root.lcConditionGuide?.destroy()));
})();
